import React from "react";
import { useSelector } from "react-redux";
import BulkAutoPricing from "./BulkAutoReprice";
import { pricing } from "../../redux/slices/pricingSlice";

// Lightweight wrapper to trigger BulkAutoPricing for the current stone only
export default function AutoPricing({
  searchParam = [],
  handleBulkClose,
  activeTab = 0,
  id = "User Diamond",
  configSort,
}) {
  const itemDetails = useSelector(pricing).itemDetails;
  const userDiamond = itemDetails?.userDiamond;

  const selectedItems = React.useMemo(() => (userDiamond ? [userDiamond] : []), [userDiamond]);

  // Reuse BulkAutoPricing dialog with a single preselected stone.
  // Use id="item-details" to ensure proper backend handling and RTK Query invalidation.
  return (
    <BulkAutoPricing
      selectedItems={selectedItems}
      allSelected={false}
      filters={[]}
      searchParam={searchParam}
      handleBulkClose={handleBulkClose}
      activeTab={activeTab}
      configSort={configSort}
      id={"User Diamond"}
    />
  );
}

